<div *ngIf="hasAnyMissingValue || !finishedAndLocked" class="btn-container ml-4">
	<button (click)="toggleMenu()" nz-button [nzType]="'default'" [disabled]="disabled"
			[ngClass]="{'active': hasAnyMissingValue}" class="bordered fehlwert f-button"
	>
		<p><workflow-missing-value-icon></workflow-missing-value-icon></p>
		<i *ngIf="!finishedAndLocked"
			nz-icon [nzType]="!showMenu ? 'caret-down' : 'caret-up'" nzTheme="outline"
			class="icon clickable chevron"
		></i>
	</button>
</div>

<div [hidden]="!showMenu" class="outer-menu">
	<div class="inner-menu">

		<p *ngIf="hasAnyMissingValue" [ngClass]="{'with-separator': !finishedAndLocked}" (click)="toggleMenu()">
			<b>{{ 'workflow.missing_value_in_use' | translate }}</b>
		</p>
		<p *ngIf="!hasAnyMissingValue" class="with-separator" (click)="toggleMenu()">
			<b>{{ 'word.missing_value' | translate }}</b>
		</p>

		<workflow-wizard-missing-value-button-element *ngFor="let entry of missingKeyEntries"
				[appWorkflowItemKey]="entry.key" [finishedAndLocked]="finishedAndLocked"
				[element]="entry" (entrySelected)="toggleMenu()" (missingValueChanged)="updateMenu(entry, $event)"
		></workflow-wizard-missing-value-button-element>

	</div>
</div>
